var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83003 14.93L14.93 4.82998C15.023 4.73625 15.1336 4.66186 15.2555 4.61109C15.3773 4.56032 15.508 4.53418 15.64 4.53418C15.772 4.53418 15.9027 4.56032 16.0246 4.61109C16.1465 4.66186 16.2571 4.73625 16.35 4.82998L19.17 7.64998C19.2638 7.74294 19.3382 7.85354 19.3889 7.9754C19.4397 8.09726 19.4658 8.22797 19.4658 8.35998C19.4658 8.49199 19.4397 8.6227 19.3889 8.74455C19.3382 8.86641 19.2638 8.97701 19.17 9.06998L9.07003 19.17C8.97741 19.2645 8.86697 19.3396 8.74509 19.3911C8.62322 19.4426 8.49234 19.4694 8.36003 19.47H5.53003C5.26481 19.47 5.01046 19.3646 4.82292 19.1771C4.63539 18.9895 4.53003 18.7352 4.53003 18.47V15.64C4.53058 15.5077 4.55738 15.3768 4.60887 15.2549C4.66037 15.133 4.73554 15.0226 4.83003 14.93Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.25977L16.74 11.4998",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.a930d33870971d2fe0d2724879e608da.svg";
export { ForwardRef as ReactComponent };